<style>
  .BeforeTr {
    background-color: red !important;
  }
</style>

<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات گواهی نامه</h5>

    <div>

      <app-DataEntityDeviceInfo 
        [inner_calibration_id]="Calibration_Device_Id"
        (outter_Calibration_Device)="Set_CalibrationDeviceInfo_click($event)">
        
      </app-DataEntityDeviceInfo>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Certificate Code </label>
            <input value="{{CertificateCode}}" disabled type="text" class="form-control">
          </div>

          <div class="form-group col-md-6">
            <app-DataEntityLabAddress [inner_Calibration_Device_Id]="Calibration_Device_Id"
              [inner_Calibration_Lab_Address]="Calibration_Device.labAdderss"
              (outter_selected_Lab_Address)="Set_LabAddress_click($event)">

            </app-DataEntityLabAddress>
          </div>


        </div>
      </form>

      <br />
      <hr />
      <br />

      <app-AddressLetterCertificate [inner_Calibration_Detail_Id]="Calibration_Device_Id">

      </app-AddressLetterCertificate>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> MANUFACTURE </label>
            <input [(ngModel)]="Manufacture_txt" name="Manufacture_txt" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> TYPE </label>
            <select class="custom-select" [(ngModel)]="Type_txt" name="Type_txt">
              <option value="">انتخاب کنید</option>
              <option value="In Box">In Box</option>
              <option value="Without Box">Without Box</option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Class </label>
            <select class="custom-select" [(ngModel)]="Model_txt" name="Model_txt">
              <option value="">انتخاب کنید</option>
              <option value="E1">E1</option>
              <option value="E2">E2</option>
              <option value="F1">F1</option>
              <option value="F2">F2</option>
              <option value="M1">M1</option>
              <option value="M1-2">M1-2</option>
              <option value="M2">M2</option>
              <option value="M2-3">M2-3</option>
              <option value="M3">M3</option>
            </select>
          </div>
        </div>
      </form>

      <form [hidden]="form_type==3">
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Range / Nominal Weight </label>
            <input [(ngModel)]="range_nominal" name="range_nominal" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> Range / Nominal Weight Unit </label>
            <select class="custom-select" [(ngModel)]="range_nominal_unit" name="range_nominal_unit">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />


      <form [formGroup]="MainFormDataEntity">

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © before </label>
            <input formControlName="Temperature_Air_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Temperature_Air_before().valid && get_Form_Temperature_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Tmperature of Air © before را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © after </label>
            <input formControlName="Temperature_Air_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Temperature_Air_after().valid && get_Form_Temperature_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Tmperature of Air © after را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) before </label>
            <input formControlName="Humidity_Air_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Humidity_Air_before().valid && get_Form_Humidity_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Humidity of Air (%rH) before را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) after </label>
            <input formControlName="Humidity_Air_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Humidity_Air_after().valid && get_Form_Humidity_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Humidity of Air (%rH) after را وارد نمائید.</small>
          </div>


        </div>

        <div class="row">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) before </label>
            <input formControlName="Pressure_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Pressure_before().valid && get_Form_Pressure_before().touched"
              class="form-text text-muted MyErrorRedColor">Ambient Pressure (hPa) before را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) after </label>
            <input formControlName="Pressure_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Pressure_after().valid && get_Form_Pressure_after().touched"
              class="form-text text-muted MyErrorRedColor">Ambient Pressure (hPa) after را وارد نمائید.</small>
          </div>
        </div>


      </form>

      <br />
      <hr />
      <br />

      <div [hidden]="form_type!=3">

        <form [formGroup]="ResolutionFormDataEntity" (submit)="Add_Resolution()">
          <div class="row">
            <div class="form-group col-md-4">
              <label for="exampleInputEmail1"> Min Rage </label>
              <input formControlName="range_min" type="text" class="form-control EnglishClm"
                placeholder="اینجا تایپ کنید ...">
            </div>

            <div class="form-group col-md-4">
              <label for="exampleInputEmail1"> Max Rage </label>
              <input formControlName="range_max" type="text" class="form-control EnglishClm"
                placeholder="اینجا تایپ کنید ...">
            </div>

            <div class="form-group col-md-4">
              <label for="exampleInputEmail1"> Unit </label>
              <select class="custom-select" formControlName="unit">
                <option value="">انتخاب کنید</option>
                <option *ngFor="let item of DataList_Unit" [value]="item.title">
                  <div innerHTML="{{item.title}}"></div>
                </option>
              </select>
            </div>
          </div>
          <button type="submit" [disabled]="!ResolutionFormDataEntity.valid" class="btn btn-success"
            style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
        </form>

        <br />
        <br />

        <div class="table-responsive" *ngIf="DataList_Resolution.length>0">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #39409b; color: white;">
              <tr>
                <th>#</th>
                <th>Min Range</th>
                <th>Max Range</th>
                <th>Unit</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of DataList_Resolution">
                <td>{{DataList_Resolution.indexOf(item)+1}}</td>
                <td class="EnglishClm">{{item.range_min}}</td>
                <td class="EnglishClm">{{item.range_max}}</td>
                <td class="EnglishClm">
                  <div innerHTML="{{item.unit}}"></div>
                </td>
                <td>
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                        <a style="cursor: pointer;" class="dropdown-item"
                          (click)="Delete_Resolution(DataList_Resolution.indexOf(item))"><i class="fa fa-remove"></i>
                          حذف
                        </a>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>


          </table>
        </div>

        <br />
        <hr />
        <br />

      </div>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> بارگذاری فایل پیوست : </label>
            <input type="file" #file_pdf>
          </div>
          <div class="form-group col-md-6">
            <img *ngIf="Procssing_Import2" src="assets/Loading.gif" style="width: 25px;" />
            <button *ngIf="!Procssing_Import2" type="button" class="btn btn-info"
              (click)="upload_file_pdf(file_pdf.files)"> بارگذاری فایل پیوست <i class="fa fa-upload"></i></button>
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />

    </div>

    <div class="card-body">
      <div class="tab nav-border" style="position: relative;">

        <div class="d-block d-md-flex justify-content-between">
          <div class="d-block d-md-flex nav-tabs-custom">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#form1" role="tab"
                  aria-controls="months" aria-selected="true">
                  <span> mg </span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link show" id="months-tab" data-toggle="tab" href="#form2" role="tab"
                  aria-controls="months" aria-selected="true">
                  <span> g </span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link show" id="months-tab" data-toggle="tab" href="#form3" role="tab"
                  aria-controls="months" aria-selected="true">
                  <span> kg </span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="tab-content" id="myTabContent">

          <div class="tab-pane fade active show" id="form1" role="tabpanel" aria-labelledby="months-tab">
            <div class="row mb-30">

              <div class="col-md-12 mb-30" style="margin-top: 100px;">

                <form>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="exampleInputEmail1"> بارگذاری فایل : </label>
                      <input type="file" #file_excel>
                    </div>
                    <div class="form-group col-md-6">
                      <img *ngIf="Procssing_Import" src="assets/Loading.gif" style="width: 25px;" />
                      <button *ngIf="!Procssing_Import && form_type!=2" type="button" class="btn btn-warning"
                        (click)="upload_file_excel(file_excel.files,1)"> بارگذاری فایل <i
                          class="fa fa-upload"></i></button>
                      <button *ngIf="!Procssing_Import && form_type==2" type="button" style="margin-right: 10px;"
                        class="btn btn-success" (click)="Add_New_Item(1)"> افزودن ردیف <i
                          class="fa fa-plus-circle"></i></button>
                      <button *ngIf="!Procssing_Import" type="button" style="margin-right: 10px;" class="btn btn-danger"
                        (click)="remove_file_excel(1)"> حذف داده های جدول نتایج <i class="fa fa-remove"></i></button>
                    </div>
                  </div>
                </form>

                <br />
                <hr />
                <br />


                <div class="table-responsive" *ngIf="Nominal_Value_List_mg.length>0">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">

                    <ng-container>



                      <tr>
                        <td colspan="8">

                          <table class="mb-0 table table-bordered table-3 text-center table-striped">

                            <thead style="background-color: #489b39; color: white;">
                              <tr>
                                <th>#</th>
                                <th>Marking / Code</th>
                                <th>Nominal value </th>
                                <th>As found</th>
                                <th>As left</th>
                                <th>Uncertainty</th>
                                <th>Converge</th>
                                <th>امکانات</th>
                              </tr>
                            </thead>

                            <tbody>
                              <ng-container>

                                <tr *ngFor="let item of Nominal_Value_List_mg"
                                  [ngClass]="{'BeforeTr': item.before==true,'AfterTr': item.before==false }">

                                  <td>{{Nominal_Value_List_mg.indexOf(item)+1}}</td>
                                  <td>
                                    <input type="text" [(ngModel)]="item.marking" />
                                  </td>
                                  <td>
                                    <input type="text" *ngIf="form_type==2" [(ngModel)]="item.nominal" />
                                    <span *ngIf="form_type!=2">{{item.nominal}}</span>
                                  </td>
                                  <td>
                                    <input type="text" *ngIf="item.before==true || form_type==2"
                                      [(ngModel)]="item.found" />
                                    <span *ngIf="item.before==false && form_type!=2">{{item.found}}</span>
                                  </td>
                                  <td>
                                    <input type="text" *ngIf="item.before==false || form_type==2"
                                      [(ngModel)]="item.left" />
                                    <span *ngIf="item.before==true && form_type!=2">{{item.left}}</span>
                                  </td>
                                  <td>
                                    <input type="text" *ngIf="form_type==2" [(ngModel)]="item.uncertainty" />
                                    <span *ngIf="form_type!=2">{{item.uncertainty}}</span>
                                  </td>
                                  <td>
                                    <input type="text" *ngIf="form_type==2" [(ngModel)]="item.converage" />
                                    <span *ngIf="form_type!=2">{{item.converage}}</span>
                                  </td>
                                  <td>
                                    <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                                      <div class="btn-group" role="group">
                                        <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                          امکانات
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                                          <a style="cursor: pointer;" *ngIf="item.before==false"
                                            (click)="Add_Before(Nominal_Value_List_mg.indexOf(item),1)"
                                            class="dropdown-item">
                                            <i class="fa fa-arrow-circle-down"></i> کپی به عنوان Before
                                          </a>

                                          <a style="cursor: pointer;" *ngIf="item.before==true"
                                            (click)="Delete_Before(Nominal_Value_List_mg.indexOf(item),1)"
                                            class="dropdown-item">
                                            <i class="fa fa-remove"></i> حذف Before
                                          </a>

                                        </div>
                                      </div>
                                    </div>

                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>

                          </table>

                        </td>
                      </tr>

                    </ng-container>

                  </table>
                </div>

              </div>

            </div>

          </div>

          <div class="tab-pane fade" id="form2" role="tabpanel" aria-labelledby="months-tab">
            <div class="row mb-30">

              <div class="col-md-12 mb-30" style="margin-top: 100px;">

                <form>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="exampleInputEmail1"> بارگذاری فایل : </label>
                      <input type="file" #file_excel1>
                    </div>
                    <div class="form-group col-md-6">
                      <img *ngIf="Procssing_Import" src="assets/Loading.gif" style="width: 25px;" />
                      <button *ngIf="!Procssing_Import && form_type!=2" type="button" class="btn btn-warning"
                        (click)="upload_file_excel(file_excel1.files,2)"> بارگذاری فایل <i
                          class="fa fa-upload"></i></button>
                      <button *ngIf="!Procssing_Import && form_type==2" type="button" style="margin-right: 10px;"
                        class="btn btn-success" (click)="Add_New_Item(2)"> افزودن ردیف <i
                          class="fa fa-plus-circle"></i></button>
                      <button *ngIf="!Procssing_Import" type="button" style="margin-right: 10px;" class="btn btn-danger"
                        (click)="remove_file_excel(2)"> حذف داده های جدول نتایج <i class="fa fa-remove"></i></button>
                    </div>
                  </div>
                </form>

                <br />
                <hr />
                <br />


                <div class="table-responsive" *ngIf="Nominal_Value_List_g.length>0">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">

                    <ng-container>

                      <tr>
                        <td colspan="8">

                          <table class="mb-0 table table-bordered table-3 text-center table-striped">

                            <thead style="background-color: #489b39; color: white;">
                              <tr>
                                <th>#</th>
                                <th>Marking / Code</th>
                                <th>Nominal value </th>
                                <th>As found</th>
                                <th>As left</th>
                                <th>Uncertainty</th>
                                <th>Converge</th>
                                <th>امکانات</th>
                              </tr>
                            </thead>

                            <tbody>
                              <ng-container>

                                <tr *ngFor="let item of Nominal_Value_List_g"
                                  [ngClass]="{'BeforeTr': item.before==true,'AfterTr': item.before==false }">

                                  <td>{{Nominal_Value_List_g.indexOf(item)+1}}</td>
                                  <td>
                                    <input type="text" [(ngModel)]="item.marking" />
                                  </td>

                                  <td>
                                    <input type="text" *ngIf="form_type==2" [(ngModel)]="item.nominal" />
                                    <span *ngIf="form_type!=2">{{item.nominal}}</span>
                                  </td>

                                  <td>
                                    <input type="text" *ngIf="item.before==true || form_type==2"
                                      [(ngModel)]="item.found" />
                                    <span *ngIf="item.before==false && form_type!=2">{{item.found}}</span>
                                  </td>

                                  <td>
                                    <input type="text" *ngIf="item.before==false || form_type==2"
                                      [(ngModel)]="item.left" />
                                    <span *ngIf="item.before==true && form_type!=2">{{item.left}}</span>
                                  </td>

                                  <td>
                                    <input type="text" *ngIf="form_type==2" [(ngModel)]="item.uncertainty" />
                                    <span *ngIf="form_type!=2">{{item.uncertainty}}</span>
                                  </td>

                                  <td>
                                    <input type="text" *ngIf="form_type==2" [(ngModel)]="item.converage" />
                                    <span *ngIf="form_type!=2">{{item.converage}}</span>
                                  </td>

                                  <td>
                                    <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                                      <div class="btn-group" role="group">
                                        <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                          امکانات
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                                          <a style="cursor: pointer;" *ngIf="item.before==false"
                                            (click)="Add_Before(Nominal_Value_List_g.indexOf(item),2)"
                                            class="dropdown-item">
                                            <i class="fa fa-arrow-circle-down"></i> کپی به عنوان Before
                                          </a>

                                          <a style="cursor: pointer;" *ngIf="item.before==true"
                                            (click)="Delete_Before(Nominal_Value_List_g.indexOf(item),2)"
                                            class="dropdown-item">
                                            <i class="fa fa-remove"></i> حذف Before
                                          </a>

                                        </div>
                                      </div>
                                    </div>

                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>

                          </table>

                        </td>
                      </tr>

                    </ng-container>

                  </table>
                </div>

              </div>

            </div>

          </div>

          <div class="tab-pane fade" id="form3" role="tabpanel" aria-labelledby="months-tab">
            <div class="row mb-30">

              <div class="col-md-12 mb-30" style="margin-top: 100px;">

                <form>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="exampleInputEmail1"> بارگذاری فایل : </label>
                      <input type="file" #file_excel2>
                    </div>
                    <div class="form-group col-md-6">
                      <img *ngIf="Procssing_Import" src="assets/Loading.gif" style="width: 25px;" />
                      <button *ngIf="!Procssing_Import && form_type!=2" type="button" class="btn btn-warning"
                        (click)="upload_file_excel(file_excel2.files,3)"> بارگذاری فایل <i
                          class="fa fa-upload"></i></button>
                      <button *ngIf="!Procssing_Import && form_type==2" type="button" style="margin-right: 10px;"
                        class="btn btn-success" (click)="Add_New_Item(3)"> افزودن ردیف <i
                          class="fa fa-plus-circle"></i></button>
                      <button *ngIf="!Procssing_Import" type="button" style="margin-right: 10px;" class="btn btn-danger"
                        (click)="remove_file_excel(3)"> حذف داده های جدول نتایج <i class="fa fa-remove"></i></button>
                    </div>
                  </div>
                </form>

                <br />
                <hr />
                <br />


                <div class="table-responsive" *ngIf="Nominal_Value_List_kg.length>0">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">

                    <ng-container>



                      <tr>
                        <td colspan="8">

                          <table class="mb-0 table table-bordered table-3 text-center table-striped">

                            <thead style="background-color: #489b39; color: white;">
                              <tr>
                                <th>#</th>
                                <th>Marking / Code</th>
                                <th>Nominal value </th>
                                <th>As found</th>
                                <th>As left</th>
                                <th>Uncertainty</th>
                                <th>Converge</th>
                                <th>امکانات</th>
                              </tr>
                            </thead>

                            <tbody>
                              <ng-container>

                                <tr *ngFor="let item of Nominal_Value_List_kg"
                                  [ngClass]="{'BeforeTr': item.before==true,'AfterTr': item.before==false }">

                                  <td>{{Nominal_Value_List_kg.indexOf(item)+1}}</td>
                                  <td>
                                    <input type="text" [(ngModel)]="item.marking" />
                                  </td>
                                  <td>
                                    <input type="text" *ngIf="form_type==2" [(ngModel)]="item.nominal" />
                                    <span *ngIf="form_type!=2">{{item.nominal}}</span>
                                  </td>
                                  <td>
                                    <input type="text" *ngIf="item.before==true || form_type==2"
                                      [(ngModel)]="item.found" />
                                    <span *ngIf="item.before==false && form_type!=2">{{item.found}}</span>
                                  </td>
                                  <td>
                                    <input type="text" *ngIf="item.before==false || form_type==2"
                                      [(ngModel)]="item.left" />
                                    <span *ngIf="item.before==true && form_type!=2">{{item.left}}</span>
                                  </td>
                                  <td>
                                    <input type="text" *ngIf="form_type==2" [(ngModel)]="item.uncertainty" />
                                    <span *ngIf="form_type!=2">{{item.uncertainty}}</span>
                                  </td>
                                  <td>
                                    <input type="text" *ngIf="form_type==2" [(ngModel)]="item.converage" />
                                    <span *ngIf="form_type!=2">{{item.converage}}</span>
                                  </td>
                                  <td>
                                    <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                                      <div class="btn-group" role="group">
                                        <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                          امکانات
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                                          <a style="cursor: pointer;" *ngIf="item.before==false"
                                            (click)="Add_Before(Nominal_Value_List_kg.indexOf(item),3)"
                                            class="dropdown-item">
                                            <i class="fa fa-arrow-circle-down"></i> کپی به عنوان Before
                                          </a>

                                          <a style="cursor: pointer;" *ngIf="item.before==true"
                                            (click)="Delete_Before(Nominal_Value_List_kg.indexOf(item),3)"
                                            class="dropdown-item">
                                            <i class="fa fa-remove"></i> حذف Before
                                          </a>

                                        </div>
                                      </div>
                                    </div>

                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>

                          </table>

                        </td>
                      </tr>

                    </ng-container>

                  </table>
                </div>

              </div>

            </div>

          </div>

        </div>
      </div>
    </div>

    <div>

      <br />
      <hr />
      <br />
      <button *ngIf="InProccessing" type="button" class="btn btn-info" style="margin-left: 5px;"> سیستم در حال ساخت
        گواهی نامه می باشد. لطفا صبر نمائید ... <i class="fa fa-spin fa-spinner"></i> </button>

      <button *ngIf="!InProccessing && !CertificateCode" type="button"
        (click)="onSubmit(templateCode,templateCodeSerialDevice,0)" class="btn btn-success" style="margin-left: 5px;"><i
          class="fa  fa-plus-circle"></i> ثبت اطلاعات گواهی نامه </button>
      <button *ngIf="!InProccessing && CertificateCode" type="button"
        (click)="onSubmit(templateCode,templateCodeSerialDevice,0)" class="btn btn-info" style="margin-left: 5px;"><i
          class="fa  fa-edit"></i>
        ویرایش
        اطلاعات گواهی نامه </button>

      <a target="_blank" *ngIf="!InProccessing && CertificateCode && CertificateUrlPdf" href="{{CertificateUrlPdf}}"
        style="margin-left: 5px;" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> فایل گواهی نامه </a>

      <button routerLink="/KartableInbox" *ngIf="!InProccessing" type="button" style="margin-left: 5px;"
        class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>

    </div>

  </div>
</div>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> کد گواهی نامه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>کد گواهی نامه فرم کالبیراسیون کد گواهی نامه <b>'{{CertificateCode}}'</b></p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCodeSerialDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> هشدار </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_CodeSerial.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <h6> {{modalRef_CodeSerial_Title}}</h6>

  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="onSubmit_Code(templateCode,templateCodeSerialDevice,1)">بله،
      مورد تایید است</button>
    <button type="button" class="btn btn-danger" (click)="modalRef_CodeSerial.hide()">خیر</button>
  </div>
</ng-template>